import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

export interface IConfirmationDialogOptions {
  title?: string;
  message: string;
  cancelButtonLabel?: string;
  confirmButtonLabel?: string;
  actionsVisible?: boolean;
}

@Component({
  selector: 'assess-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public options: IConfirmationDialogOptions) {}
}
